/* TailmiPaws: shared promotional free-shipping display for Agile 3.8.0.
 * Presentation ONLY: the actual shipping discount is configured in Shopify Discounts.
 * Uses a live browser clock (not cached Liquid 'now') and one time zone for both cart UIs.
 */
(function () {
  'use strict';
  if (window.__tailmiShippingPromoInitialized) return;
  window.__tailmiShippingPromoInitialized = true;

  function localDateInZone(zone) {
    var formatter;
    try {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: zone || 'America/Los_Angeles',
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
    } catch (error) {
      formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric', month: '2-digit', day: '2-digit'
      });
    }
    var parts = formatter.formatToParts(new Date());
    var values = {};
    for (var i = 0; i < parts.length; i++) values[parts[i].type] = parts[i].value;
    return values.year + '-' + values.month + '-' + values.day;
  }

  function validDate(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
    var date = new Date(value + 'T00:00:00Z');
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === value;
  }

  function currentCampaign(widget) {
    if (widget.getAttribute('data-promo-enabled') !== 'true') return null;
    var schedule = widget.getAttribute('data-promo-schedule') || '';
    var today = localDateInZone(widget.getAttribute('data-promo-timezone'));
    var rows = schedule.split(/\r?\n/);
    for (var i = 0; i < rows.length; i++) {
      var values = rows[i].trim().split('|');
      if (values.length < 3) continue;
      var start = values[0].trim();
      var end = values[1].trim();
      if (!validDate(start) || !validDate(end) || start >= end) continue;
      if (today >= start && today < end) {
        return values.slice(2).join('|').trim() || 'Free U.S. shipping. No minimum.';
      }
    }
    return null;
  }

  function refresh() {
    var widgets = document.querySelectorAll('[data-tailmi-free-shipping]');
    widgets.forEach(function (widget) {
      var progress = widget.querySelector('free-ship-progress-bar');
      var promo = widget.querySelector('.tailmi-free-shipping-promo');
      var promoText = widget.querySelector('.tailmi-free-shipping-promo-text');
      if (!progress || !promo || !promoText) return;

      var message = currentCampaign(widget);
      if (message) {
        if (promoText.textContent !== message) promoText.textContent = message;
        if (progress.style.display !== 'none') progress.style.display = 'none';
        if (promo.style.display !== 'block') promo.style.display = 'block';
      } else {
        if (promo.style.display !== 'none') promo.style.display = 'none';
        if (progress.style.display === 'none') progress.style.display = '';
      }
    });
  }

  var queued = false;
  function scheduleRefresh() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () {
      queued = false;
      refresh();
    });
  }

  function start() {
    refresh();
    // Agile re-renders the cart through Ajax. Observe new markup without re-running scripts.
    if (document.body && window.MutationObserver) {
      var observer = new MutationObserver(scheduleRefresh);
      observer.observe(document.body, { childList: true, subtree: true });
    }
    // Refresh at date boundaries even when the customer leaves the cart open.
    window.setInterval(refresh, 30000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) refresh();
    });
    window.addEventListener('pageshow', refresh);
    document.addEventListener('shopify:section:load', scheduleRefresh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
